<template>
	<div>
		<a @click="activePrompt = true">
			<div class="flex flex-col items-center justify-center">
				<vx-tooltip
					style="z-index: 99999"
					:title="$t('Export')"
					color="primary"
					position="bottom"
					:text="$t('Export') + ' ' + $t('MapModule.RealTimeTracking')"
				>
					<vs-icon icon="cloud_download" class="cursor-pointer" size="medium" color="secondary"></vs-icon>
				</vx-tooltip>
				<small>{{ $t("Export") }}</small>
			</div>
		</a>
		<vs-prompt
			:title="$t('Export') + ' ' + $t('MapModule.RealTimeTracking')"
			class="export-options"
			@cancel="clearFields"
			@accept="exportToExcel"
			:accept-text="$t('Export')"
			:cancel-text="$t('Cancel')"
			@close="clearFields"
			:active.sync="activePrompt"
			:is-valid="validName"
		>
			<vs-input v-model.trim="fileName" :placeholder="$t('EnterFileName')" class="w-full" />
			<v-select v-model="selectedFormat" :options="formats" class="my-4">
				<template v-slot:no-options="{search, searching}">
					<template v-if="searching">
						{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
					</template>
				</template>
			</v-select>
			<div class="flex">
				<span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
				<vs-switch v-model="cellAutoWidth">{{ $t("CellAutoWidth") }}</vs-switch>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import vSelect from "vue-select";
import DateUtils from "@/helpers/DateUtils.js";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
			dataExport: [{name: "felix", id: "masa"}],
			activePrompt: false,
			fileName: "",
			formats: ["xlsx", "csv", "txt"],
			cellAutoWidth: true,
			selectedFormat: "xlsx",
			headerVal: [
				"id",
				"active",
				"name",
				"lastname",
				"identification",
				"username",
				"email",
				"date",
				"address",
				"city",
				"cx",
				"cy",
				"battery",
				"alias",
				"version",
				"version_os",
			],
		};
	},
	computed: {
		resources() {
			return this.$store.state.moduleResource.resources;
		},
		headerTitle() {
			return [
				"id",
				this.$t("MapModule.OnLine"),
				this.$t("Name"),
				this.$t("Lastname"),
				this.$t("Identification"),
				this.$t("Username"),
				this.$t("Email"),
				this.$t("Date"),
				this.$t("Address"),
				this.$t("City"),
				this.$t("Longitude"),
				this.$t("Latitude"),
				this.$t("Alarm.BatteryLevel"),
				this.$t("Role"),
				this.$t("MapModule.mobile_app_version"),
				this.$t("MapModule.android_os_version"),
			];
		},
		validName() {
			return this.fileName.length > 0 && this.fileName !== "";
		},
	},
	methods: {
		transformData() {
			return new Promise((resolve, reject) => {
				const resourceWithTracking = this.resources
					.filter((r) => r.tracking)
					.map((r) => {
						const {alias, email, id, identification, lastname, name, username, tracking} = r;
						return {alias, email, id, identification, lastname, name, username, tracking};
					})
					.map((r) => {
						const {tracking, ...rest} = r;
						const {active, address, battery, city, cx, cy, date, version, version_os, ...rest2} = tracking;
						return {...rest, active, address, battery, city, cx, cy, date, version, version_os};
					});

				const resourceWithoutTracking = this.resources
					.filter((r) => !r.tracking)
					.map((r) => {
						const {alias, email, id, identification, lastname, name, username} = r;
						return {
							alias,
							email,
							id,
							identification,
							lastname,
							name,
							username,
							active: "",
							address: "",
							battery: "",
							city: "",
							cx: "",
							cy: "",
							date: "",
							version: "",
							version_os: "",
						};
					});

				const activeResources = resourceWithTracking.filter((r) => r.active);
				const inactiveResources = resourceWithTracking.filter((r) => !r.active);
				const mixedArray = [...activeResources, ...inactiveResources, ...resourceWithoutTracking];

				if (mixedArray.length > 0) resolve(mixedArray);
				else reject([]);
			});
		},
		async exportToExcel() {
			const dateTime = DateUtils.toDefaultDateTime(new Date());
			try {
				this.$vs.loading();
				const transformedData = await this.transformData();
				import("@/vendor/Export2Excel").then((excel) => {
					const data = this.formatJson(this.headerVal, transformedData);
					excel.export_json_to_excel({
						header: this.headerTitle,
						data,
						filename: this.fileName.toLowerCase() + "_" + dateTime,
						autoWidth: this.cellAutoWidth,
						bookType: this.selectedFormat,
					});
					this.clearFields();
					this.$vs.loading.close();
				});
			} catch (error) {
				console.error(error);
				this.$vs.loading.close();
			}
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					return v[j];
				})
			);
		},
		clearFields() {
			this.fileName = "";
			this.cellAutoWidth = true;
			this.selectedFormat = "xlsx";
		},
	},
};
</script>

<style></style>
